import { isSG } from "@/config/appVersion";

const parseBool = (value, fallback = false) => {
  if (value === undefined || value === null || value === "") {
    return fallback;
  }
  const normalized = String(value).trim().toLowerCase();
  return ["1", "true", "yes", "on"].includes(normalized);
};

const parseNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const apiUrlBase = String(process.env.VUE_APP_API_URL || "").replace(/\/+$/, "");
const sgDefaultTilesUrl = apiUrlBase
  ? `${apiUrlBase}/tiles/{z}/{x}/{y}.png`
  : "/api/v1/tiles/{z}/{x}/{y}.png";

export const MAP_TILES_URL_TEMPLATE =
  process.env.VUE_APP_MAP_TILES_URL_TEMPLATE ||
  (isSG ? sgDefaultTilesUrl : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png");

export const MAP_TILES_ATTRIBUTION =
  process.env.VUE_APP_MAP_TILES_ATTRIBUTION || (isSG ? "" : "&copy; OpenStreetMap contributors");

export const MAP_TILES_MIN_ZOOM = parseNumber(process.env.VUE_APP_MAP_TILES_MIN_ZOOM, 0);
export const MAP_TILES_MAX_ZOOM = parseNumber(process.env.VUE_APP_MAP_TILES_MAX_ZOOM, 18);
export const MAP_TILES_TMS = parseBool(process.env.VUE_APP_MAP_TILES_TMS, false);
export const MAP_TILES_NO_WRAP = parseBool(process.env.VUE_APP_MAP_TILES_NO_WRAP, false);

const subdomainsRaw = process.env.VUE_APP_MAP_TILES_SUBDOMAINS;
export const MAP_TILES_SUBDOMAINS =
  typeof subdomainsRaw === "string" && subdomainsRaw.trim()
    ? subdomainsRaw.split(",").map((v) => v.trim()).filter(Boolean)
    : "abc";
